module.exports = __webpack_public_path__ + "img/Gedeck.9ea1bd7b.jpg";